import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import partner1 from '../../../../assets/images/technology/partners/c1.svg';
import partner2 from '../../../../assets/images/technology/partners/c2.svg';
import partner3 from '../../../../assets/images/technology/partners/c3.svg';
import partner4 from '../../../../assets/images/technology/partners/c4.svg';
import partner5 from '../../../../assets/images/technology/partners/c5.svg';
import './Partners.css';

const partners = [
  { name: 'Layers', logo: partner1 },
  { name: 'Sisyphus', logo: partner2 },
  { name: 'Circooles', logo: partner3 },
  { name: 'Catalog', logo: partner4 },
  { name: 'Quotient', logo: partner5 },
];

const Partners = () => {
  return (
    <section className="technology-partners">
      <div className="technology-partners__inner">
        <Reveal>
          <p className="technology-partners__title">
            Our Strategic Technology Partners
          </p>
        </Reveal>

        <Reveal className="technology-partners__logos" delay={80}>
          {partners.map(({ name, logo }) => (
            <img
              key={name}
              className="technology-partners__logo"
              src={logo}
              alt={name}
            />
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Partners;
